import { CompanyRegistration, CompanyRegistrationErrors } from '../types';

export const validateCompanyForm = (formData: Partial<CompanyRegistration>): CompanyRegistrationErrors => {
  const errors: CompanyRegistrationErrors = {};

  if (!formData.razonSocial || formData.razonSocial.length < 3) {
    errors.razonSocial = 'La razón social debe tener al menos 3 caracteres.';
  }

  if (!formData.nombreFantasia || formData.nombreFantasia.length < 3) {
    errors.nombreFantasia = 'El nombre de fantasía debe tener al menos 3 caracteres.';
  }

  if (!formData.direccion || formData.direccion.length < 10) {
    errors.direccion = 'La dirección debe ser más específica.';
  }

  if (!formData.provincia) {
    errors.provincia = 'Debes seleccionar una provincia.';
  }

  if (!formData.localidad || formData.localidad.length < 3) {
    errors.localidad = 'La localidad debe tener al menos 3 caracteres.';
  }

  if (!formData.codigoPostal || formData.codigoPostal.length < 3) {
    errors.codigoPostal = 'El código postal debe tener al menos 3 caracteres.';
  }

  if (!formData.ddn || formData.ddn.length < 2) {
    errors.ddn = 'El DDN debe tener al menos 2 dígitos.';
  }

  if (!formData.telefono1 || formData.telefono1.length < 7) {
    errors.telefono1 = 'El teléfono debe tener al menos 7 dígitos.';
  }

  if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = 'Por favor ingresa un email válido.';
  }

  if (!formData.tipoActividad) {
    errors.tipoActividad = 'Debes seleccionar el tipo de actividad.';
  }

  if (!formData.descripcion || formData.descripcion.length < 20) {
    errors.descripcion = 'La descripción debe tener al menos 20 caracteres.';
  }

  if (!formData.rubros || formData.rubros.length < 10) {
    errors.rubros = 'Los rubros deben tener al menos 10 caracteres.';
  }

  if (!formData.comoNosConocio) {
    errors.comoNosConocio = 'Debes seleccionar cómo nos conociste.';
  }

  if (!formData.contacto || formData.contacto.length < 3) {
    errors.contacto = 'El nombre del contacto debe tener al menos 3 caracteres.';
  }

  if (!formData.usuario || formData.usuario.length < 3) {
    errors.usuario = 'El nombre de usuario debe tener al menos 3 caracteres.';
  }

  if (!formData.password || formData.password.length < 3) {
    errors.password = 'La contraseña debe tener al menos 3 caracteres.';
  }

  if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = 'Las contraseñas no coinciden.';
  }

  if (!formData.terminos) {
    errors.terminos = 'Debes aceptar los términos y condiciones.';
  }

  return errors;
};
